
const video_link =
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Video/testimonial_video_STPSFH.mp4";
function TestimonailVideo() {   


    return (
        <div className="testimonial_video_home">
            <div className="maintitle m-auto">
        <p>what parents say</p>
        <h1>Parent Testimonials</h1>
      </div>
            <div className="container">
              
               <div className="video_sec">
  <video width="100%" height="400" autoPlay muted controls playsInline loop>
    <source src={video_link} type="video/mp4" />
  </video>
</div>

            </div>
        </div>
    )

}

export default TestimonailVideo;
